import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import {useSettings} from '@store/settings'

import Prompt from '@utils/Prompt';

import Settings from '@model/settings'

export const useSetup = defineStore('setup', () => {
    const $settings = useSettings()

    const setup = ref({
        type: '', // business|personal
    })

    const isBusiness = ref($settings.addons['staffs'])

    const setupStep = computed(() => prebook_admin.setup.step || 'type')

    // Ajax to save setup step.
    const saveSetupStep = async (step) => {
        const response = await Settings.init().saveSetupStep({ step })
    }

    const crossButton = async () => {
        let choice = await Prompt.fire({
            title: 'Warning',
            message: `This will return you to WordPress dashboard. <br> All your changes will be lost! `,
            ok: 'Yes, proceed',
            cancel: 'No, cancel',
        });

        if (choice.ok) {
            window.location.href = prebook_admin.site.admin_url;
        }

    }

    return {
        setup,
        isBusiness,
        saveSetupStep,
        setupStep,
        crossButton,
    }
})
